import { ExpandArrowIcon, ShrinkArrowIcon, TimeSheetIcon } from '@sketchnote/icons';
import Tippy from '@tippyjs/react';
import { useCallback, useEffect, useMemo, useState } from 'react';
// import differenceInMilliseconds from 'date-fns/differenceInMilliseconds';
import { TimerTracker } from 'src/features/tasks/components/TimeTrackerDetails';

import { useTimerWidgetStore } from './useTimerWidgetStore';

export const TimerNavbar = () => {
  const [showTime, setShowTime] = useState<string>('00 : 00 : 00');
  const {
    setIsRunningTimersModalOpen,
    isMinimized,
    minimize,
    maximize,
    timers,
    fetchTimers,
    selectedTimerIndex,
  } = useTimerWidgetStore((s) => ({
    setIsRunningTimersModalOpen: s.setIsRunningTimersModalOpen,
    isMinimized: s.isMinimized,
    maximize: s.maximize,
    minimize: s.minimize,
    timers: s.timers,
    fetchTimers: s.fetchTimers,
    selectedTimerIndex: s.selectedTimerIndex,
  }));
  const ICON_SIZE = 16;

  useEffect(() => {
    fetchTimers();
  }, []);

  const runningTimers = useMemo(() => {
    return timers.filter((timer) => timer.isRunning);
  }, [timers]);

  const handleMinimize = () => {
    if (isMinimized) {
      maximize();
    } else {
      minimize();
    }
  };

  return (
    <div id="timer-navbar" className="mx-8 border rounded-full p-1 border-gray-200">
      <div className="border flex rounded-full items-center px-2 py-1 border-gray-130">
        <Tippy
          className="w-auto h-auto bg-gray-999 tippy"
          placement="bottom"
          content="Show active timers"
        >
          <button
            onClick={() => setIsRunningTimersModalOpen(true)}
            style={{
              borderRadius: '50%',
            }}
          >
            <div className="flex items-center justify-center w-24 h-24 rounded-full">
              <TimeSheetIcon size={20} className="text-primary-500" />
            </div>
          </button>
        </Tippy>
        {/* <span className="text-xs text-gray-600 min-w-60 text-center hidden">{showTime}</span> */}
        {runningTimers?.[selectedTimerIndex]?._id && isMinimized && (
          <div className="min-w-75 flex justify-center items-center">
            <TimerTracker
              className="text-xs text-gray-600 text-center"
              startTime={runningTimers[selectedTimerIndex]?.startTime}
              stopTime={runningTimers[selectedTimerIndex]?.stopTime}
              isRunning={runningTimers[selectedTimerIndex]?.isRunning}
              timeTrackedTaskId={runningTimers[selectedTimerIndex]?.task._id}
            />
          </div>
        )}
        <button
          onClick={handleMinimize}
          className="bg-gray-100 ml-7 rounded-full p-4 w-20 h-20 flex items-center justify-center text-gray-400 hover:bg-gray-200 hover:text-gray-500 cursor-pointer"
        >
          {isMinimized ? (
            <ExpandArrowIcon size={ICON_SIZE} />
          ) : (
            <ShrinkArrowIcon size={ICON_SIZE} />
          )}
        </button>
      </div>
    </div>
  );
};
